import dynamic from 'next/dynamic';

import { Link } from '@natu/next-link';
import { PredefinedGAEvents } from '@natu/utils/events';

import { type ButtonProps } from '../Button/Button';
import { DynamicIcon } from '../DynamicIcon/DynamicIcon';

const Button = dynamic(() => import('../Button/Button').then(mod => mod.Button));

const ButtonWithEvent = dynamic(() =>
  import('../Button/ButtonWithEvent').then(mod => mod.ButtonWithEvent),
);

export interface ArticleButtonProps {
  label?: string;
  href?: string;
  event?: PredefinedGAEvents;
  descriptiveText?: string;
}

export const ArticleButton = ({
  label,
  href,
  event,
  descriptiveText,
  ...rest
}: ArticleButtonProps) => {
  if (!href || !label) return null;

  const buttonProps = {
    className: 'justify-start gap-2 text-[13px] font-bold',
    size: 'link',
    variant: 'link',
    asChild: true,
  } as ButtonProps;

  if (event)
    return (
      <ButtonWithEvent event={event} {...buttonProps} {...rest}>
        <Link href={href}>
          {label}
          {descriptiveText && <span className="sr-only">{descriptiveText}</span>}
          <DynamicIcon icon="arrowRight" className="mb-1" />
        </Link>
      </ButtonWithEvent>
    );

  return (
    <Button {...buttonProps} {...rest}>
      <Link href={href}>
        {label}
        {descriptiveText && <span className="sr-only">{descriptiveText}</span>}
        <DynamicIcon icon="arrowRight" className="mb-1" />
      </Link>
    </Button>
  );
};
